module.exports = __webpack_public_path__ + "static/media/50men.a43acf64.svg";